import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mic } from "lucide-react";
import { api } from "@/lib/api";

export const VoiceRangeCard = () => {
  const [vr, setVr] = useState(null);
  useEffect(() => { api.get("/me/voice-range").then(({ data }) => setVr(data?.low ? data : null)).catch(() => {}); }, []);
  if (!vr) return null;
  return (
    <div className="mt-8 flex flex-wrap items-center gap-4 rounded-2xl border border-border bg-card p-5" data-testid="dashboard-voice-range">
      <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary/10 text-primary"><Mic size={18} /></span>
      <div>
        <p className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">Your vocal range</p>
        <p className="mt-1 text-foreground"><strong data-testid="dashboard-voice-range-notes">{vr.low}–{vr.high}</strong> · Suggested part: <strong className="text-primary" data-testid="dashboard-voice-range-part">{vr.part}</strong></p>
      </div>
      <Link to="/lessons/1" className="ml-auto text-sm text-primary hover:underline" data-testid="dashboard-voice-range-retest">Test again →</Link>
    </div>
  );
};
